<template>
  <div class="card-container">
    <div class="card">
      <div class="icon"></div>
      <div class="member-type">进阶会员</div>
      <div class="line"></div>
      <div class="right">
        <div class="one">注册会员手机号：188 8888 8888</div>
        <div class="two">已参加进阶会员学习计划{{ day }}日</div>
      </div>
    </div>
    <el-button type="primary" @click="onSignOut" class="sign-out-btn">退出登录</el-button>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const day = ref(0)

const onSignOut = () => {
  window.localStorage.removeItem('token')
  router.push('/signIn')
}
</script>
<style scoped>
.card-container {
  display: flex;
  justify-content: space-between;
  width: 1080px;
  position: relative;
}
.card {
  width: fit-content;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  padding: 4px;
  color: #fff;
  background-color: var(--background-color);
}
.member-type {
  font-size: 24px;
  font-weight: 700;
}
.line {
  width: 1px;
  height: 60px;
  background-color: #fff;
}
.right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.one {
  color: #aaa;
  font-size: 12px;
}
.two {
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
}
.sign-out-btn {
  position:absolute;
  top: 20px;
  right: 20px;
}
</style>